import { Card, Heading, Box, Flex, Button } from "theme-ui";
import { InfoMessage } from "../InfoMessage";
import { useStakingView } from "./context/StakingViewContext";
import { Icon } from "../Icon";
import { useLiquitySelector } from "@liquity/lib-react";
import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquity } from "../../hooks/LiquityContext";
import { useTransactionFunction } from "../Transaction";

const selector = (state: LiquityStoreState) => {
  const { accountBalance, sPrintAllowance, sPrintBalance } = state;
  return {
    accountBalance,
    sPrintAllowance,
    sPrintBalance
  };
};

type ApprovalActionProps = {
  transactionId: string;
};

export const ApproveAction: React.FC<ApprovalActionProps> = ({
  children,
  transactionId
}) => {
  const { liquity } = useLiquity();

  const [sendTransaction] = useTransactionFunction(
    transactionId,
    liquity.send.approveSPrintTokens.bind(liquity.send, "115792089237316195423000000000000000000")
  );

  return <Button onClick={sendTransaction}>{children}</Button>;
};

export const NoStake: React.FC = () => {
  const { dispatch } = useStakingView();

  const { sPrintAllowance } = useLiquitySelector(selector);
  const sprintAllowance = Number(sPrintAllowance) / 1e18;

  return (
    <Card>
      <Heading>
        <div>
          <Icon style={{ marginRight: 10, color: "#00afff" }} name="database" />
          Liquid Staked PRINT (sPRINT)
        </div>
      </Heading>
      <Box sx={{ p: [2, 3] }}>
        <InfoMessage title={`You do not have sPRINT.`}>
          Get sPRINT to participate in zero impermanent loss farms. Convert PRINT to sPRINT and redeem anytime 1:1.
        </InfoMessage>

        <Flex variant="layout.actions">
          { sprintAllowance > 0 ?
            (<Button onClick={() => dispatch({ type: "startAdjusting" })}>
            Convert PRINT to sPRINT
            </Button>) : (
              <ApproveAction transactionId={"sprint-approval"}>
                Approve
              </ApproveAction>
            )
          }
        </Flex>
      </Box>
    </Card>
  );
};
